import { struct } from 'io-ts/Decoder';

import { Id as FileId } from './Id';
import { ParentId } from './ParentId';

export const ComplexId = struct({
	parentId: ParentId,
	fileId: FileId,
});
